import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { Button } from "antd";
import { ProdekoIcon } from "./ProdekoIcon";
import { useTranslation } from ".";
export function SocialLoginOptions({ next, buttonTextFromService, }) {
    const { t } = useTranslation();
    const defaultButtonTextFromService = useCallback((service) => `${t("common:signinWith")} ${service}`, [t]);
    return (_jsx(Button, { href: `/auth/oauth2?next=${encodeURIComponent(next)}`, icon: _jsx(ProdekoIcon, { size: "20px", style: { verticalAlign: "middle" } }), size: "large", type: "primary", block: true, children: buttonTextFromService
            ? buttonTextFromService("Prodeko")
            : defaultButtonTextFromService("Prodeko") }));
}
//# sourceMappingURL=SocialLoginOptions.js.map